var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / arrow right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 12C19.9999 12.2652 19.8945 12.5195 19.707 12.707L13.707 18.707C13.5184 18.8892 13.2658 18.99 13.0036 18.9877C12.7414 18.9854 12.4906 18.8803 12.3052 18.6949C12.1198 18.5095 12.0146 18.2586 12.0123 17.9964C12.01 17.7342 12.1108 17.4816 12.293 17.293L16.586 13L5 13C4.73478 13 4.48043 12.8947 4.29289 12.7071C4.10536 12.5196 4 12.2653 4 12C4 11.7348 4.10536 11.4805 4.29289 11.2929C4.48043 11.1054 4.73478 11 5 11L16.586 11L12.293 6.70704C12.1108 6.51844 12.01 6.26584 12.0123 6.00364C12.0146 5.74144 12.1198 5.49063 12.3052 5.30522C12.4906 5.11981 12.7414 5.01465 13.0036 5.01237C13.2658 5.01009 13.5184 5.11088 13.707 5.29304L19.707 11.293C19.8945 11.4805 19.9999 11.7348 20 12Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.ddf712aa104bed84c21c2578a0e8926a.svg";
export { ForwardRef as ReactComponent };